import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={9}
    fill="none"
    {...props}
  >
    <path
      stroke="#383838"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m1 1 8.724 7.203L18.177 1"
    />
  </svg>
)
export default SvgComponent
